module.exports = __webpack_public_path__ + "static/img/14.a1c52da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/14.png
// module id = qxQ+
// module chunks = 0